import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { projectsData } from '../mockData';

const Projects = () => {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Complete Home', 'Bedroom', 'Kitchen', 'Dining', 'Office'];

  const filteredProjects = filter === 'All' 
    ? projectsData 
    : projectsData.filter(project => project.category === filter);

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-[#F5F1E8]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-6 font-poppins">
              Our Projects
            </h1>
            <p className="text-xl text-gray-700 leading-relaxed">
              Explore our portfolio of beautifully crafted interiors, complete home makeovers, and bespoke furniture designs.
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <Button
                key={category}
                onClick={() => setFilter(category)}
                variant={filter === category ? 'default' : 'outline'}
                className={`transition-all ${
                  filter === category
                    ? 'bg-[#2F4538] hover:bg-[#243629] text-white'
                    : 'border-[#2C2C2C] text-[#2C2C2C] hover:bg-[#F5F1E8]'
                }`}
              >
                {category}
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {filteredProjects.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredProjects.map((project) => (
                <Link
                  key={project.id}
                  to={`/projects/${project.id}`}
                  className="group block"
                >
                  <Card className="border-none shadow-lg overflow-hidden hover:shadow-xl transition-all">
                    <div className="relative h-64 overflow-hidden">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                      <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                        <span className="inline-block bg-white/90 backdrop-blur-sm text-[#2C2C2C] px-3 py-1 rounded-full text-sm font-medium">
                          {project.type}
                        </span>
                      </div>
                    </div>
                    <CardContent className="p-6">
                      <h3 className="text-xl font-semibold text-[#2C2C2C] mb-2 font-poppins group-hover:text-[#2F4538] transition-colors">
                        {project.title}
                      </h3>
                      <p className="text-gray-600 mb-2">{project.location}</p>
                      <p className="text-gray-700 text-sm line-clamp-2">{project.description}</p>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-600 text-lg">No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Projects;